export const DESCRIPTION_PREVIEW_HEIGHT = 600;
